import { render, staticRenderFns } from "./item-cards.vue?vue&type=template&id=59d6f667&"
import script from "./item-cards.vue?vue&type=script&lang=js&"
export * from "./item-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports